// Test IDs for septic tank and plumbing features

export const SEPTIC = {
    // Nav & Tabs
    navCalculator: 'nav-calculator',
    navServiceArea: 'nav-service-area',
    navContact: 'nav-contact',
    navAdmin: 'nav-admin',

    // Estimator Calculator
    bedroomsSelect: 'estimator-bedrooms-select',
    usageSelect: 'estimator-usage-select',
    soilSelect: 'estimator-soil-select',
    calculateButton: 'estimator-calculate-button',
    estimationResult: 'estimator-result',
    lockPriceButton: 'estimator-lock-price-button',

    // Service Area Checker
    zipInput: 'service-area-zip-input',
    checkZipButton: 'service-area-check-button',
    checkerResult: 'service-area-result',

    // Lead Form
    leadNameInput: 'lead-form-name-input',
    leadEmailInput: 'lead-form-email-input',
    leadPhoneInput: 'lead-form-phone-input',
    leadZipInput: 'lead-form-zip-input',
    leadServiceSelect: 'lead-form-service-select',
    leadMessageInput: 'lead-form-message-input',
    leadSubmitButton: 'lead-form-submit-button',
    leadSuccessAlert: 'lead-form-success-alert',

    // Chatbot
    chatOpenButton: 'chat-open-button',
    chatCloseButton: 'chat-close-button',
    chatMessageInput: 'chat-message-input',
    chatSendButton: 'chat-send-button',
    chatHistoryContainer: 'chat-history-container',
    chatMessageItem: 'chat-message-item',

    // Admin Dashboard
    adminNavLeads: 'admin-nav-leads',
    adminNavChats: 'admin-nav-chats',
    adminNavSettings: 'admin-nav-settings',
    leadsTable: 'admin-leads-table',
    leadStatusSelect: 'admin-lead-status-select',
    leadDeleteButton: 'admin-lead-delete-button',
    chatSessionItem: 'admin-chat-session-item',
    chatSessionMessages: 'admin-chat-session-messages',
    settingBaseCostInput: 'admin-setting-base-cost-input',
    settingSaveButton: 'admin-setting-save-button',
};
